import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import feedbackImage from '../../../../assets/images/feedback-success.png';
import { Image } from '../../../../components/NPS/components/ThanksForFeedback/components/Image.js';
import { HeadlineLarge, ParagraphMedium, Stack } from '../../../../primitives/index.js';
import { qaId } from '../../../../utils/index.js';
import { NPS_FEEDBACK_QA_ID } from '../../../../utils/qaId.js';
export const ThanksForFeedback = () => {
  const {
    t
  } = useTranslation('NPS');
  const mdUp = useBreakpointUp('md');
  return _jsxs(_Fragment, {
    children: [_jsx(HeadlineLarge, {
      children: t('thanksForFeedback.title')
    }), _jsxs(Stack, {
      direction: mdUp ? 'row' : 'column',
      spacing: 1.25,
      alignItems: "center",
      children: [_jsx(Image, {
        "data-testid": (qaId(NPS_FEEDBACK_QA_ID), 'thanksForFeedbackImage'),
        src: feedbackImage,
        alt: ""
      }), _jsx(ParagraphMedium, {
        children: t('thanksForFeedback.text')
      })]
    })]
  });
};